import AccountSettingsIcon from '@/components/tenants/jikord/icons/AccountSettingsIcon.vue';
import BankCardApplicationIcon from '@/components/tenants/jikord/icons/BankCardApplicationIcon.vue';
import ElectronicWalletIcon from '@/components/tenants/jikord/icons/EWalletIcon.vue';
import ExternalCardApplicationIcon from '@/components/tenants/jikord/icons/ExternalCardApplicationIcon.vue';
import LogoutIcon from '@/components/tenants/jikord/icons/LogoutIcon.vue';
import ManagedCardListIcon from '@/components/tenants/jikord/icons/ManagedCardListIcon.vue';
import MenuIcon from '@/components/tenants/jikord/icons/MenuIcon.vue';
import NewCardApplicationIcon from '@/components/tenants/jikord/icons/NewCardApplicationIcon.vue';
import NotificationSettingIcon from '@/components/tenants/jikord/icons/NotificationSettingIcon.vue';
import OrderListIcon from '@/components/tenants/jikord/icons/OrderListIcon.vue';
import PencilIcon from '@/components/tenants/jikord/icons/PencilIcon.vue';
import ReclamationIcon from '@/components/tenants/jikord/icons/ReclamationIcon.vue';
import SettingsIcon from '@/components/tenants/jikord/icons/SettingsIcon.vue';
import ShoppingCardIcon from '@/components/tenants/jikord/icons/ShoppingCardIcon.vue';
import TicketFareIcon from '@/components/tenants/jikord/icons/TicketFareIcon.vue';
import UserAccountIcon from '@/components/tenants/jikord/icons/UserIcon.vue';

export const jikordIcons = {
  account: UserAccountIcon,
  accountSettingsIcon: AccountSettingsIcon,
  bankCardApplicationIcon: BankCardApplicationIcon,
  cardManagingAccountIcon: ExternalCardApplicationIcon,
  electronicWalletIcon: ElectronicWalletIcon,
  externalCardApplicationIcon: ExternalCardApplicationIcon,
  logoutIcon: LogoutIcon,
  managedCardListIcon: ManagedCardListIcon,
  menuIcon: MenuIcon,
  newCardApplicationIcon: NewCardApplicationIcon,
  notificationSettingIcon: NotificationSettingIcon,
  orderListIcon: OrderListIcon,
  pencil: PencilIcon,
  reclamationIcon: ReclamationIcon,
  settingsIcon: SettingsIcon,
  shoppingCartIcon: ShoppingCardIcon,
  ticketFareIcon: TicketFareIcon,
};
